import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  date: string;
  categoryName: string;
  categorySlug: string;
}

export default function ArticleCard({ slug, title, excerpt, date, categoryName, categorySlug }: ArticleCardProps) {
  return (
    <article className="p-4 md:p-5 rounded-lg bg-background-50 border border-background-200/70 hover:border-accent-300 transition-all duration-200 group cursor-pointer">
      <Link to={`/article/${slug}`} className="block" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
        <div className="flex items-center gap-2 mb-2.5 flex-wrap">
          <Link
            to={`/category/${categorySlug}`}
            className="inline-block px-2.5 py-0.5 text-xs font-medium rounded-full bg-accent-100 text-accent-700 hover:bg-accent-200 transition-colors cursor-pointer"
            onClick={(e) => { e.stopPropagation(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
          >
            {categoryName}
          </Link>
          <time className="text-xs text-foreground-400">{date}</time>
        </div>
        <h3 className="text-base md:text-lg font-semibold text-foreground-900 group-hover:text-accent-600 transition-colors leading-snug mb-2">
          {title}
        </h3>
        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
          {excerpt}
        </p>
        <div className="mt-3 flex items-center text-sm text-accent-600 font-medium">
          <span>阅读全文</span>
          <i className="ri-arrow-right-line ml-1 group-hover:translate-x-1 transition-transform"></i>
        </div>
      </Link>
    </article>
  );
}